import {GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/export/GenogramExportConstants";

export default class GenogramExportDiagnosticLogger {

	log(event, payload = {}) {
		console.log(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} ${event}`, JSON.stringify(this.buildPayload(payload)))
	}

	warn(event, payload = {}) {
		console.warn(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} ${event}`, JSON.stringify(this.buildPayload(payload)))
	}

	buildPayload(payload) {
		return {
			...payload,
			memory: this.getMemorySnapshot(),
			ts: Date.now(),
		}
	}

	getMemorySnapshot() {
		let performanceMemory = typeof window !== "undefined" ? window.performance?.memory : null

		if (!performanceMemory) {
			return {
				available: false,
			}
		}

		return {
			available: true,
			jsHeapSizeLimit: performanceMemory.jsHeapSizeLimit,
			totalJSHeapSize: performanceMemory.totalJSHeapSize,
			usedJSHeapSize: performanceMemory.usedJSHeapSize,
		}
	}
}
